import { render } from "./HeaderSearch.vue?vue&type=template&id=9f9ea3b4"
import script from "./HeaderSearch.vue?vue&type=script&lang=js"
export * from "./HeaderSearch.vue?vue&type=script&lang=js"
script.render = render

export default script